import { TaskGroupingId } from "../hooks/useTaskGrouping";
import { produceTasksPageViewSpecificStorageHook } from "./storageHookProducers";

export const useTaskGroupingIdStorage =
  produceTasksPageViewSpecificStorageHook<TaskGroupingId>({
    storageName: "TASK_GROUPING_ID",
    storageType: "local",
    getInitialValue: ({ isDemo, taskView }) =>
      isDemo && taskView.type === "kanban" ? "status" : "default",
  });
